import PropTypes from "prop-types";
import { memo } from "react";
import { useSelector } from "react-redux";

import {
  ELEVATOR_ALL_INOPERABLE,
  ELEVATOR_ALL_OPERABLE,
  ELEVATOR_AT_LEAST_ONE_INOPERABLE,
  ELEVATOR_AT_LEAST_ONE_UNKNOWN,
} from "../constants";

import {
  Elevator,
  ElevatorBroken,
  ElevatorGray,
  ElevatorYellow,
} from "./icons";

import "./StationIconElevatorLegend.scss";

function StationIconElevatorLegend({
  elevatorOutOfOrder = null,
  elevators,
  elevatorState = null,
}) {
  const config = useSelector((state) => state.config?.stationIcons);

  const inactive = elevators?.INACTIVE || [];

  if (!config.hasElevator) {
    return null;
  }

  if (config.hasElevatorState) {
    const allOperable = elevatorState === ELEVATOR_ALL_OPERABLE;
    const allInoperable = elevatorState === ELEVATOR_ALL_INOPERABLE;
    const someInoperable = elevatorState === ELEVATOR_AT_LEAST_ONE_INOPERABLE;
    const someUnknown = elevatorState === ELEVATOR_AT_LEAST_ONE_UNKNOWN;
    return (
      <div className="trl-elevator-status-legend">
        {allOperable && (
          <div className="trl-elevator-info">
            <Elevator className="trl-popup-station-icon" />
            <span className="trl-popup-station-label">
              Alle Aufzüge in Betrieb
            </span>
          </div>
        )}
        {allInoperable && (
          <div className="trl-elevator-info">
            <ElevatorBroken className="trl-popup-station-icon" />
            <span className="trl-popup-station-label">
              Alle Aufzüge außer Betrieb
            </span>
          </div>
        )}
        {someInoperable && (
          <div className="trl-elevator-info">
            <ElevatorYellow className="trl-popup-station-icon" />
            <div>
              <span className="trl-popup-station-label">Außer Betrieb</span>
              <ul>
                {inactive.map((item) => {
                  return (
                    <li data-testid="elevator-inoperable" key={item}>
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
        {someUnknown && (
          <div className="trl-elevator-info">
            <ElevatorGray className="trl-popup-station-icon" />
            <span className="trl-popup-station-label">
              Kein Aufzugstatus bekannt
            </span>
          </div>
        )}
      </div>
    );
  }
  if (config.hasElevatorOutOfOrder) {
    return (
      <div className="trl-elevator-status-legend">
        {!!elevatorOutOfOrder && (
          <div className="trl-elevator-info">
            <ElevatorBroken className="trl-popup-station-icon" />
            <div>
              <span className="trl-popup-station-label">Außer Betrieb</span>
              {inactive.length && (
                <ul>
                  {inactive.map((item) => {
                    return (
                      <li data-testid="elevator-inoperable" key={item}>
                        {item}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        )}
        {!elevatorOutOfOrder && (
          <div className="trl-elevator-info">
            <Elevator className="trl-popup-station-icon" />
            <span className="trl-popup-station-label">
              Alle Aufzüge in Betrieb
            </span>
          </div>
        )}
      </div>
    );
  }
  return null;
}

StationIconElevatorLegend.propTypes = {
  elevatorOutOfOrder: PropTypes.bool,
  elevators: PropTypes.object,
  elevatorState: PropTypes.string,
};

export default memo(StationIconElevatorLegend);
